import {
  CREATE_USER_RESET,
  CREATE_USER_SUCCESS,
  CREATE_USER_START,
  CREATE_USER_FAIL,
  GET_USERS_START,
  GET_USERS_SUCCESS,
  GET_USERS_FAIL,
  GET_USER_START,
  GET_USER_SUCCESS,
  GET_USER_FAIL,
  UPDATE_USER_RESET,
  UPDATE_USER_START,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  // DELETE_USER_START,
  // DELETE_USER_SUCCESS,
  // DELETE_USER_FAIL,
  DEACTIVATE_USER_START,
  DEACTIVATE_USER_SUCCESS,
  DEACTIVATE_USER_FAIL,
  UPDATE_SEARCHTERMS,
  UPDATE_USER_SETTINGS,
  GET_QUICKNOTES_SUCCESS,
  GET_QUICKNOTES_START,
  UPDATE_QUICKNOTES,
  DELETE_QUICKNOTES,
  CHANGE_TRIP_STATUS_START,
  CHANGE_TRIP_STATUS_SUCCESS,
  CHANGE_TRIP_STATUS_FAIL,
  PUSH_DRIVER_LOC_START,
  PUSH_DRIVER_LOC_SUCCESS,
  PUSH_DRIVER_LOC_FAIL,
  USER_RESET_PWD_START,
  USER_RESET_PWD_SUCCESS,
  USER_RESET_PWD_FAIL,
  USER_CHANGE_PWD_START,
  USER_CHANGE_PWD_SUCCESS,
  USER_CHANGE_PWD_FAIL,
} from '../constants/index'
import handleIDB from 'src/utils/handle-indexed-db'
import userReducerInitialState from './userReducerInitialState'
import { isCustomer } from 'src/utils/check-user-level'
import { getFullName, uniqueById } from 'src/utils/helpers'

const reducer = (state = userReducerInitialState, action) => {
  console.log('userReducer', action)

  switch (action.type) {
    // CREATE USER

    case CREATE_USER_RESET:
      return {
        ...state,
        createdUser: {
          success: false,
          isLoading: false,
          errors: [],
          data: {},
          msg: '',
        },
        deactivatedUser: {
          msg: '',
          data: {},
          success: false,
          isLoading: false,
          errors: [],
        },
      }
    case CREATE_USER_START:
      return {
        ...state,
        createdUser: {
          ...state.createdUser,
          success: false,
          isLoading: true,
          errors: [],
          msg: 'Creatring...',
        },
      }
    case CREATE_USER_SUCCESS:
      const foundIdx = state.usersList?.data?.findIndex((u) => u._id === action?.payload?.user?._id)
      const userData =
        foundIdx === -1
          ? [...(state?.usersList?.data || []), action.payload?.user]
          : state?.usersList?.data
      const newDestData =
        foundIdx === -1 && isCustomer(action.payload?.user)
          ? [
              ...state.destinationsList.data,
              { ...action.payload.user, name: getFullName({ user: action.payload?.user }) },
            ]
          : state.destinationsList.data
      return {
        ...state,
        createdUser: { ...action.payload.user, isLoading: false, success: true },
        usersList: {
          data: userData,
          isLoading: false,
          success: true,
        },
        destinationsList: {
          data: newDestData,
          isLoading: false,
          success: true,
        },
      }
    case CREATE_USER_FAIL:
      return {
        ...state,
        createdUser: { ...state.payload, isLoading: false, errors: action?.payload },
      }

    // GET USERS

    case GET_USERS_START:
      return {
        ...state,
        usersList: { ...state.usersList, success: false, isLoading: true, errors: [] },
      }
    case GET_USERS_SUCCESS:
      const custsToDest = action?.payload?.length
        ? action.payload
            .filter((u) => !u?.isDeactivated)
            // .filter((u) => isCustomer(u) && !u.isDeactivated)
            .map((c) => ({
              ...c,
              name: `${c.firstName} ${c.lastName}'s Home`,
            }))
        : []
      return {
        ...state,
        usersList: {
          data: uniqueById([
            ...state?.usersList?.data?.filter((u) => !u.isDeactivated),
            ...(action?.payload || []),
          ]),
          count: action?.count || state?.usersList?.count,
          // data: action?.payload,
          isLoading: false,
          success: true,
        },
        destinationsList: {
          ...state.destinationsList,
          data: uniqueById([...(state?.destinationsList?.data || []), ...custsToDest]), // getRemainingItems(state?.destinationsList?.data, custsToDest),
        },
      }
    case GET_USERS_FAIL:
      return {
        ...state,
        usersList: { ...state.usersList, isLoading: false, errors: action?.payload },
      }

    // GET USER

    case GET_USER_START:
      return {
        ...state,
        user: {
          ...state.user,
          msg: '',
          data: {},
          success: false,
          isLoading: true,
          errors: [],
        },
      }
    case GET_USER_SUCCESS:
      return {
        ...state,
        user: {
          success: true,
          isLoading: false,
          data: action?.payload,
          errors: [],
        },
      }
    case GET_USER_FAIL:
      return {
        ...state,
        user: {
          ...state.user,
          isLoading: false,
          errors: action?.payload,
        },
      }

    // UPDATE USER

    case UPDATE_USER_RESET:
      return {
        ...state,
        updatedUser: {
          isLoading: false,
          msg: '',
          data: {},
          errors: [],
        },
        deactivatedUser: {
          msg: '',
          data: {},
          isLoading: false,
          errors: [],
        },
      }
    case UPDATE_USER_START:
      return {
        ...state,
        updatedUser: {
          ...state.updatedUser,
          msg: 'Updating...',
          data: {},
          success: false,
          isLoading: true,
          errors: [],
        },
      }
    case UPDATE_USER_SUCCESS:
      const { user: updatedU } = action?.payload
      const filteredUsers = state?.usersList?.data?.filter(
        (u) => u._id !== action?.payload?.user?._id,
      )
      const cToDest = {
        ...updatedU,
        name: `${updatedU.firstName} ${updatedU.lastName}'s Home`,
      }
      const filteredDsts = state?.destinationsList?.data?.filter((d) => d._id !== updatedU?._id)
      return {
        ...state,
        updatedUser: {
          ...action.payload,
          isLoading: false,
          success: true,
          errors: [],
        },
        usersList: {
          data: [...(filteredUsers || []), updatedU],
          success: true,
          isLoading: false,
        },
        destinationsList: {
          ...state.destinationsList,
          data: [...(filteredDsts || []), cToDest], // getRemainingItems(state?.destinationsList?.data, custsToDest),
        },
      }
    case UPDATE_USER_FAIL:
      return {
        ...state,
        updatedUser: {
          ...state.updatedUser,
          isLoading: false,
          errors: action?.payload,
        },
      }

    // DEACTIVATE USER

    case DEACTIVATE_USER_START:
      return {
        ...state,
        deactivatedUser: {
          ...state.deactivatedUser,
          success: false,
          isLoading: true,
          errors: [],
          msg: 'Loading...',
        },
      }
    case DEACTIVATE_USER_SUCCESS:
      const activeUsers = state.usersList?.data?.filter((u) => u._id !== action?.payload?.user?._id)
      return {
        ...state,
        deactivatedUser: {
          ...action.payload,
          success: true,
          isLoading: false,
          errors: [],
        },
        usersList: {
          data: [...activeUsers, action.payload.user],
          success: true,
          isLoading: false,
        },
      }
    case DEACTIVATE_USER_FAIL:
      return {
        ...state,
        deactivatedUser: { ...state.payload, isLoading: false, errors: action?.payload, msg: '' },
      }

    case UPDATE_SEARCHTERMS:
      const searchTerms = {
        ...state.searchTerms,
        ...action.payload,
      }
      handleIDB?.put({
        model: 'Searchterms',
        _id: 'searchTerms',
        data: {
          constraint: searchTerms.constraint,
          constraintReport: searchTerms.constraintReport,
          productsLogsConstraint: searchTerms.productsLogsConstraint,
          tripState: searchTerms.tripState,
          driver: searchTerms.driver,
          selectedDrivers: searchTerms.selectedDrivers,
          customer: searchTerms.customer,
          destination: searchTerms.destination,
          page: searchTerms.page,
        },
      })
      return {
        ...state,
        searchTerms,
      }
    case UPDATE_USER_SETTINGS:
      return {
        ...state,
        userSettings: {
          ...state.userSettings,
          ...action.payload,
        },
      }
    case GET_QUICKNOTES_START:
      return {
        ...state,
        quickNotes: {
          data: [],
          isLoading: true,
          success: false,
        },
      }
    case GET_QUICKNOTES_SUCCESS:
      return {
        ...state,
        quickNotes: {
          data: [...(state?.quickNotes?.data || []), ...(action.payload || [])],
          isLoading: false,
          success: true,
        },
      }
    case UPDATE_QUICKNOTES:
      const filteredQn = state.quickNotes.data.filter(
        (n) => n.content.toLowerCase() !== action?.payload?.newQn.content.trim().toLowerCase(),
      )
      return {
        ...state,
        quickNotes: {
          data: [action?.payload?.newQn, ...filteredQn],
          isLoading: false,
          success: true,
        },
      }
    case DELETE_QUICKNOTES:
      const remainingQns = state.quickNotes.data?.filter((n) => n?.content !== action.payload)
      return {
        ...state,
        quickNotes: {
          data: remainingQns,
          isLoading: false,
          success: true,
        },
      }

    // CHANGE TRIP STATUS
    case CHANGE_TRIP_STATUS_START:
      return {
        ...state,
        changedStatusTrip: {
          msg: '',
          data: {},
          isLoading: true,
          errors: [],
        },
      }
    case CHANGE_TRIP_STATUS_SUCCESS:
      return {
        ...state,
        changedStatusTrip: {
          success: true,
          isLoading: false,
          data: action.payload,
          errors: [],
        },
      }
    case CHANGE_TRIP_STATUS_FAIL:
      return {
        ...state,
        changedStatusTrip: {
          ...state.changedStatusTrip,
          isLoading: false,
          errors: action.payload,
        },
      }

    // PUSH DRIVER LOCATION

    case PUSH_DRIVER_LOC_START:
      return {
        ...state,
        pushedLocTrip: {
          msg: '',
          data: {},
          isLoading: true,
          errors: [],
        },
      }
    case PUSH_DRIVER_LOC_SUCCESS:
      return {
        ...state,
        pushedLocTrip: {
          success: true,
          isLoading: false,
          data: action.payload,
          errors: [],
        },
      }
    case PUSH_DRIVER_LOC_FAIL:
      return {
        ...state,
        pushedLocTrip: {
          ...state.pushedLocTrip,
          isLoading: false,
          errors: action.payload,
        },
      }

    // PWD RESET

    case USER_RESET_PWD_START:
      return {
        ...state,
        resetPwd: {
          msg: 'Requesting! Please wait...',
          isLoading: true,
          errors: [],
        },
      }
    case USER_RESET_PWD_SUCCESS:
      return {
        ...state,
        resetPwd: {
          success: true,
          isLoading: false,
          msg: action?.payload?.msg,
          errors: [],
        },
      }
    case USER_RESET_PWD_FAIL:
      return {
        ...state,
        resetPwd: {
          ...state.resetPwd,
          msg: '',
          isLoading: false,
          errors: action?.payload,
        },
      }

    // PWD CHANGE

    case USER_CHANGE_PWD_START:
      return {
        ...state,
        changePwd: {
          msg: 'Requesting! Please wait...',
          isLoading: true,
          errors: [],
        },
      }
    case USER_CHANGE_PWD_SUCCESS:
      return {
        ...state,
        changePwd: {
          success: true,
          isLoading: false,
          msg: action?.payload?.msg,
          errors: [],
        },
      }
    case USER_CHANGE_PWD_FAIL:
      return {
        ...state,
        changePwd: {
          ...state.changePwd,
          msg: '',
          isLoading: false,
          errors: action?.payload,
        },
      }

    default:
      return state
  }
}

export default reducer
